var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._m(0),_c('ul',[_c('li',[_vm._v("14 dagar")]),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.cartTotal.grand_total.title)+": ")]),_c('span',{staticClass:"has-text-danger"},[_vm._v(_vm._s(_vm._f("sek")(_vm.cartTotal.grand_total.value)))])])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('strong',[_vm._v("Faktura")])])
}]

export { render, staticRenderFns }